import DOMPurify from "dompurify";

const options = {
  ALLOWED_TAGS: [
    "b",
    "i",
    "em",
    "strong",
    "a",
    "div",
    "br",
    "span",
    "p",
    "li",
    "ul",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

const sanitize = (dirty) => ({
  __html: DOMPurify.sanitize(dirty, { ...options }),
});

export default sanitize;
